// utils/numberUtil.js

/**
 * 숫자에 천 단위 콤마 추가
 * @param {number|string} value
 * @returns {string}
 */
export function formatNumberWithComma(value) {
    if (value == null || isNaN(value)) return '0';
    return Number(value).toLocaleString();
  }
  
  /**
   * 콤마 제거 후 숫자로 변환
   * @param {string} value
   * @returns {number}
   */
  export function removeComma(value) {
    if (!value) return 0;
    return Number(value.toString().replace(/,/g, ''));
  }
  